import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=e4b5c9de&"
import script from "./TheMenu.vue?vue&type=script&lang=ts&"
export * from "./TheMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TheMenu.vue?vue&type=style&index=0&id=e4b5c9de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports